import mutations from './mutations'
import actions from './actions'

const state = {
	quickData:[],	//
	question:[],  //同步习题选中的题需要的值
	wrong:[],//高频错题
	knowledgeid:[],   //知识点视频章节id
	knowledgedata:[],   //知识点视频章节发布作业的时候需要的数据
	exercisesid:[],	//同步习题预览需要的所有id
	exercisestitle:'', //同步习题预览需要的title
	exercisesdetails:[] , //同步习题
	// 同步习题 单元复习 需要的数据
	chapterid:[],  	//章节需要的id
	screenid:[],	//是筛选页的id
	releaseid:[],  	//作业预览组合发布作业的数据
	qid:[],  		//自选题所有的qid储存
	sendid:[],  	//自选题所有的qid储存  发布用
	goback:true,		//发布作业的返回判断

	tasks: [],  // dowork全部习题
	work_submit: [],  // 选择题提交数据
	single_reslut:[], //结果页单个题数据
};


export default {
  state,
  mutations
}
